const floorplan = {
  floorplan: "Plan d'étage",
  add_floorplan: "Nouveau plan d'étage",
  upload_floorplan: "Télécharger le plan d'étage",
  remove_floorplan: "Supprimer le plan d'étage",
  live_view: 'Vue en direct',
  live_view_title: "Plan d'étage - Vue en direct - {{name}}",
  delete_image_msg:
    "Êtes-vous sûr de vouloir supprimer l'image du plan d'étage ?",
  last_activity: 'Derniers événements',
  events: 'Événements',
  no_events: "PAS D'ÉVÉNEMENTS",
  disable_credential: "Désactiver l'identifiant",
  disable_credential_msg:
    'Êtes-vous sûr de vouloir désactiver cet identifiant ?',
  credential_disabled: 'Identifiant désactivé',
  all: 'Tous',
  snap_to_grid_while_dragging: 'Aligner sur la grille pendant le glissement',
  snap_to_grid_after_drop: 'Aligner sur la grille après le dépôt',
  form: {
    available_allusers: 'Disponible pour tous les utilisateurs',
    small_icons: 'Petites icônes',
    doors: 'Portes',
  },
};

export default floorplan;
